import React, { useEffect, useRef, useState } from "react";
import { commonFilter, convertCase, getUniqueFilteredData } from "../Helper/utils";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import { GetTestITData } from "../../APIServices/ProductionService/ITServices/ITThunk";
import { useTranslation } from 'react-i18next';


const CommonSearch = ({ inputFields, values, callName, errorMessage, handleFilterData,
  setValues, handleActiveField, data, handleDropdownClick, handleIpClick,disabledFields }) => {
  const dropdownRef = useRef(null);
  const { DisassembleData } = useSelector((state) => state.Disassemble);
  const [dropdownVisibility, setDropdownVisibility] = useState({});
  const [filteredResults, setFilteredResults] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [getData, setGetData] = useState([]);
  const [headerData, setHeaderData] = useState("");
  const [searchData, setSearchData] = useState(false);
  const { TestITData, loading } = useSelector((state) => state.InvTransfer || {});
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // If the click is outside the dropdown, reset visibility
        setDropdownVisibility({});
      }
    };
    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    // Cleanup the event listener when component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (TestITData && !loading.ITItemData && searchData) {
      const filter = getUniqueFilteredData(TestITData && TestITData.item1, headerData);
      setFilteredResults(filter);
      setSearchData(false);
    }
  }, [TestITData, loading.ITItemData, searchData]);

  const handleInputChange = (e, field) => {
    const { value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value
    }));
    let filter = [];
    if (callName === 'ItInput') {
      if (field === 'batch_Number' && values.item_Code) {
        dispatch(GetTestITData({ search_term: value, prev_value: values.item_Code, search_field: field }));
        setHeaderData(field);
        setSearchData(true);
      } else {
        dispatch(GetTestITData({ search_term: value, prev_value: "", search_field: field }));
        setHeaderData(field);
        setSearchData(true);
      }
    } else {
      // filterData(field, value);
      filter = commonFilter(data, field, value);
    }
    

    setFilteredResults(filter);
  };

  const handleItemClick = (item, fieldName) => {
    setSearchData(false);
    setDropdownVisibility((prev) => ({
      ...prev,
      [fieldName]: false  // Show dropdown for the corresponding field
    }));
    handleDropdownClick(item, fieldName);
  };

  const handleInputClick = async (header) => {
    setDropdownVisibility(() => ({
      [header]: true, // Hide the dropdown for the active field
    }));
    if (handleIpClick) {
      handleIpClick();
    }

    if (callName === 'ItInput') {
      let getDatas = [];
      if (TestITData) {
        if (header === 'batch_Number' && values.item_Code) {
          dispatch(GetTestITData({ search_term: "", prev_value: values.item_Code, search_field: header }));
          setHeaderData(header);
          setSearchData(true);
        } else {
          dispatch(GetTestITData({ search_term: "", prev_value: "", search_field: header }));
          setHeaderData(header);
          setSearchData(true);
        }
      }

      setGetData(getDatas);
      setFilteredResults(getDatas);
    }
    else {
      setFilteredResults(data);
    }
  };

  return (
    <div className="row Commonsearch-main">
      {/* Render each input field dynamically based on inputFields array */}
      {inputFields?.map((field, index) => (

        <div key={index} className=" mb-3 position-relative">
          <TextField
            id={field}
            className="form-control custom-modal-textfield"
            label={`${t(convertCase(field))}`}
            autoComplete="off"
            onClick={() => {
              // Only call handleInputClick if it exists
              if (handleInputClick) {
                handleInputClick(field);  // Call the handleInputClick if it's passed as a prop
              }
            }}
            onFocus={() => {
              if (handleActiveField) {
                handleActiveField(field)
              }
            }}
            disabled={disabledFields && disabledFields.includes(field)}
            value={values && (field === 'Batch_Number' ? values.batch_Number || '' : values[field] || '')}   // Use the value passed from the parent component
            onChange={(e) => handleInputChange(e, field)}  // Handle change dynamically
            style={{ outline: "none", boxShadow: "none" }}
            error={errorMessage && errorMessage[field]}
            helperText={errorMessage && errorMessage[field]}
          />
          {/* Dropdown for suggestions */}
          {dropdownVisibility[field] && (
            <ul
              ref={dropdownRef}
              className="list-group position-absolute"
              style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 10 }}>
              {filteredResults?.length > 0 ? (
                filteredResults?.map((item, index) => (
                  <li
                    key={index}
                    className="list-group-item list-group-item-action"
                    onClick={() => handleItemClick(item, field)}
                    style={{ cursor: 'pointer' }}
                  >
                    {field === 'poDocNum' ? (
                      <>
                        {item.poDocNum} / {item.vehicleNumber}
                      </>
                    ) : field === 'vehicleNumber' ? (
                      <>
                        {item.vehicleNumber} / {item.poDocNum}
                      </>
                    ) : field === 'vehicle_Number' ? (   // delivery Screen
                      <>
                        {item.vehicle_Number} / {item.pick_List_Number}
                      </>
                    )
                      : field === 'Vehicle_Number' ? (
                        <>
                          {item.vehicle_Number} / {item.customerCode}
                        </>
                      ): field === 'itemCode' ? (
                        <>
                          {item.itemCode}
                        </>
                      ): field === 'dscription' ? (
                        <>
                          {item.dscription}
                        </>
                      )
                      : field === 'Batch_Number' ? (
                        <>
                          {item.batch_Number}
                        </>
                      )
                      : field === 'delivery_Number' ? (
                        <>
                          {item.Delivery_Number}
                        </>
                      ) : item[field]}
                  </li>
                ))
              ) : (
                <li className="list-group-item " style={{ cursor: 'default' }}>
                  No data found
                </li>
              )}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default CommonSearch;